import { Module } from 'vuex';
import { ApplicationsState } from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const applications: Module<ApplicationsState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default applications;
